import type { Product } from '../../modules/productsListing/types'

export const isSubscriptionsPath = (pathname?: string) =>
  Boolean(pathname?.includes('subscriptions'))

export const resolveCloudAndProductTitleProduct = (
  selectedProduct: Product | undefined,
  products: Product[],
  productId?: string
): Product =>
  selectedProduct ||
  products.find(product => product.productId === productId) ||
  ({} as Product)
